import { setExtendedContentWidth } from './set-extended-content-width';
import type { Actions } from './types';

export const actions: Actions = {
	setExtendedContentWidth,
};

export type { Actions };
